var PRODUCT_CODE_ID_DIFF = 10000;
export var getProductIdFromProductCode = function getProductIdFromProductCode(productCode) {
  return productCode - PRODUCT_CODE_ID_DIFF;
};
export var getProductCodeFromProductId = function getProductCodeFromProductId(productId) {
  return productId + PRODUCT_CODE_ID_DIFF;
};